import type {Ref} from 'vue'
import type {adminFileType} from "~~/schemas/main.schema.dto";

export const useAdminDataStore = defineStore('adminData',() => {

        const allFilesEverLoaded: Ref<adminFileType[]> = ref([])
        const filesSelected = computed(() => {
            return allFilesEverLoaded.value.filter(f => f.selected)
        })
        // const foldersSelected = computed(() => {
        //     return allFolderEverLoaded.value.filter(f => f.selected)
        // })
        const filesSelectedIDs = computed(() => {
            return filesSelected.value.map(f => f.id).filter(id => id !== undefined) as number[]
        })

        return {
            allFilesEverLoaded, filesSelected, filesSelectedIDs,
        }
    }
)

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAdminDataStore, import.meta.hot))
}